// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1894":"9d30d5afd766dfd1","2515":"204eee5f29fcf012","2801":"081038707ca8d1ab","2866":"2fcbfc18b18fd88b","7904":"66ddc40ff50c29d2","9402":"d3431bf4da02770c"}[chunkId] + ".js";
};